import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import CelularMaskInput from '../masks/CelularMaskInput';
import { formatCelular, unformatCelular } from '../../utils/celularUtils';
import { formatTelefone, unformatTelefone } from '../../utils/telefoneUtils';
import TelefoneMaskInput from '../masks/TelefoneMaskInput';
import CEPMaskInput from '../masks/CEPMaskInput';
import { formatCEP, unformatCEP } from '../../utils/cepUtils';
import DefaultModal from './DefaultModal';
import CNPJMaskInput from '../masks/CNPJMaskInput';
import { formatCNPJ, isValidCNPJ, unformatCNPJ } from '../../utils/cnpjUtils';
import CPFMaskInput from '../masks/CPFMaskInput';
import { formatCPF, isValidCPF, unformatCPF } from '../../utils/cpfUtils';

function limparTelefone(telefone) {
  return telefone ? telefone.replace(/\D/g, '').slice(0, 10) : '';
}

function limparCelular(celular) {
  return celular ? celular.replace(/\D/g, '').slice(0, 11) : '';
}

function FavorecidoModal({
  show,
  onClose,
  onSubmit,
  favorecido = null,
  isEditing = false,
  title = 'CADASTRO DE FAVORECIDO',
}) {
  const [formData, setFormData] = useState({
    cnpjAssociacao: '',
    cpfOrCnpj: '',
    nome: '',
    telefone: '',
    celular: '',
    email: '',
    logrNome: '',
    logrNum: '',
    logrCompl: '',
    logrBairro: '',
    logrCep: '',
    logrUf: '',
    logrCidade: '',
    tipoPessoa: 'PJ',
  });

  const [UFs, setUFs] = useState([]);
  const [cidades, setCidades] = useState([]);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const [modalData, setModalData] = useState({
    show: false,
    type: '',
    message: '',
  });
  const [cnpjError, setCnpjError] = useState('');
  const [cpfError, setCpfError] = useState('');
  const [isBuscandoCnpj, setIsBuscandoCnpj] = useState(false);
  const [cidadesKey, setCidadesKey] = useState(0);
  const refs = useRef({});

  const showDefaultModal = (type, message) => {
    setModalData({ show: true, type, message });
  };

  const closeDefaultModal = () => {
    setModalData(prevModalData => ({ ...prevModalData, show: false }));
  };

  useEffect(() => {
    if (show) {
      // Reset modalData quando o FavorecidoModal é aberto
      setModalData({
        show: false,
        type: '',
        message: '',
      });

      if (isEditing && favorecido) {
        const tipoPessoa = favorecido.tipo || 'PJ';
        setFormData({
          ...favorecido,
          cnpjAssociacao: cnpj || favorecido.cnpjAssociacao,
          tipoPessoa,
          cpfOrCnpj: favorecido.cpfOrCnpj || '',
        });
      } else {
        setFormData(prev => ({
          ...prev,
          cnpjAssociacao: cnpj || '',
          tipoPessoa: 'PJ',
          cpfOrCnpj: '',
          nome: '',
          telefone: '',
          celular: '',
          email: '',
          logrNome: '',
          logrNum: '',
          logrCompl: '',
          logrBairro: '',
          logrCep: '',
          logrUf: '',
          logrCidade: '',
        }));
      }
      setCnpjError('');
      setCpfError('');

      axios
        .get(`${API_BASE_URL.UF}/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setUFs(result.data);
        })
        .catch(error => {
          console.error('Erro ao obter listas:', error);
        });
    }
  }, [show]);

  useEffect(() => {
    if (formData.logrUf) {
      axios
        .get(`${API_BASE_URL.MUNICIPIO}/uf/${formData.logrUf}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setCidades(result.data);
          if (formData.logrCidade) {
            const norm = s =>
              s
                ? s
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toUpperCase()
                : '';
            const match = result.data.find(
              c => norm(c.nome) === norm(formData.logrCidade)
            );
            if (match && match.nome !== formData.logrCidade) {
              setFormData(f => ({ ...f, logrCidade: match.nome }));
            }
          }
        })
        .catch(error => {
          console.error('Erro ao carregar cidades:', error);
        });
    } else {
      setCidades([]);
    }
  }, [formData.logrUf, cidadesKey, token]);

  function stripMask(value) {
    return value ? value.replace(/\D/g, '') : '';
  }

  async function handleBuscarCnpj() {
    const cnpjNum = stripMask(formData.cpfOrCnpj);
    if (cnpjNum.length !== 14) {
      showDefaultModal(
        'error',
        'Digite um CNPJ válido antes de buscar.'
      );
      return;
    }
    setIsBuscandoCnpj(true);
    try {
      const r = await axios.get(`${API_BASE_URL.CNPJ_PROXY}/${cnpjNum}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const d = typeof r.data === 'string' ? JSON.parse(r.data) : r.data;
      if (d.status === 'ERROR') {
        showDefaultModal('error', d.message || 'CNPJ não encontrado.');
        return;
      }
      setFormData(f => ({
        ...f,
        nome: d.nome || f.nome,
        email: d.email || f.email,
        telefone: d.telefone || f.telefone,
        logrNome: d.logradouro || f.logrNome,
        logrNum: d.numero || f.logrNum,
        logrCompl: d.complemento || f.logrCompl,
        logrBairro: d.bairro || f.logrBairro,
        logrCep: (d.cep || '').replace(/\D/g, '') || f.logrCep,
        logrUf: d.uf || f.logrUf,
        logrCidade: d.municipio || f.logrCidade,
      }));
      setCidadesKey(k => k + 1);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 429) {
        showDefaultModal(
          'error',
          'Limite de consultas atingido. Aguarde 1 minuto e tente novamente.'
        );
      } else if (status === 400) {
        showDefaultModal('error', 'CNPJ inválido.');
      } else {
        showDefaultModal(
          'error',
          `Erro ao consultar CNPJ${status ? ` (${status})` : ''}. Tente novamente em instantes.`
        );
      }
    } finally {
      setIsBuscandoCnpj(false);
    }
  }

  const handleChange = e => {
    const { name, value } = e.target;

    if (name === 'tipoPessoa') {
      setFormData({
        ...formData,
        [name]: value,
        cpfOrCnpj: '',
      });
      setCnpjError('');
      setCpfError('');
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const unformattedFavorecido = {
      ...formData,
      cpfOrCnpj:
        formData.tipoPessoa === 'PJ'
          ? unformatCNPJ(formData.cpfOrCnpj)
          : unformatCPF(formData.cpfOrCnpj),
      telefone: limparTelefone(formData.telefone),
      celular: limparCelular(formData.celular),
      tipo: formData.tipoPessoa,
    };

    delete unformattedFavorecido.tipoPessoa;

    if (formData.tipoPessoa === 'PJ') {
      if (!isValidCNPJ(unformattedFavorecido.cpfOrCnpj)) {
        setCnpjError('CNPJ inválido');
        setCpfError('');
        return;
      }
    } else {
      if (!isValidCPF(unformattedFavorecido.cpfOrCnpj)) {
        setCpfError('CPF inválido');
        setCnpjError('');
        return;
      }
    }

    setCnpjError('');
    setCpfError('');

    axios
      .post(`${API_BASE_URL.FAVORECIDO}/save`, unformattedFavorecido, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        showDefaultModal('success', 'Favorecido cadastrado com sucesso!');
        setTimeout(() => {
          closeDefaultModal();
          onSubmit && onSubmit(result.data);
          onClose && onClose();
        }, 1500);
      })
      .catch(error => {
        console.error('Erro ao salvar favorecido:', error);
        showDefaultModal(
          'error',
          'Erro ao salvar favorecido. Verifique os dados e tente novamente.'
        );
      });
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1055,
          position: 'fixed',
          inset: 0,
        }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div
              className="modal-header bg-success text-white"
              style={{ height: '30px' }}
            >
              <h5 className="modal-title mb-0">
                <i className="bi bi-person-check me-2"></i>
                {title}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-2">
                  {/* Tipo de Pessoa */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">Tipo de Pessoa</label>
                    <select
                      className="form-select form-select-sm"
                      name="tipoPessoa"
                      value={formData.tipoPessoa}
                      onChange={handleChange}
                      required
                      disabled={isEditing}
                    >
                      <option value="PJ">Pessoa Jurídica</option>
                      <option value="PF">Pessoa Física</option>
                    </select>
                  </div>

                  {/* CPF/CNPJ */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">
                      {formData.tipoPessoa === 'PJ' ? 'CNPJ' : 'CPF'}
                    </label>
                    <div className="input-group input-group-sm">
                      {formData.tipoPessoa === 'PJ' ? (
                        <CNPJMaskInput
                          value={formatCNPJ(formData.cpfOrCnpj)}
                          onChange={e =>
                            handleChange({
                              target: {
                                name: 'cpfOrCnpj',
                                value: unformatCNPJ(e.target.value),
                              },
                            })
                          }
                          name="cpfOrCnpj"
                          ref={el => (refs.current.cpfOrCnpj = el)}
                          type="text"
                          required
                          disabled={isEditing}
                        />
                      ) : (
                        <CPFMaskInput
                          value={formatCPF(formData.cpfOrCnpj)}
                          onChange={e =>
                            handleChange({
                              target: {
                                name: 'cpfOrCnpj',
                                value: unformatCPF(e.target.value),
                              },
                            })
                          }
                          name="cpfOrCnpj"
                          ref={el => (refs.current.cpfOrCnpj = el)}
                          type="text"
                          required
                          disabled={isEditing}
                        />
                      )}
                      {formData.tipoPessoa === 'PJ' && (
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm"
                          onClick={handleBuscarCnpj}
                          disabled={isBuscandoCnpj}
                          title="Buscar dados na Receita Federal"
                        >
                          {isBuscandoCnpj ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            />
                          ) : (
                            <i className="bi bi-search" />
                          )}
                        </button>
                      )}
                    </div>
                    {cnpjError && (
                      <small className="text-danger">{cnpjError}</small>
                    )}
                    {cpfError && (
                      <small className="text-danger">{cpfError}</small>
                    )}
                  </div>

                  {/* Nome */}
                  <div className="col-12 col-sm-6 col-md-6">
                    <label className="form-label mb-1">Nome</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Telefone */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">Telefone</label>
                    <div className="input-group input-group-sm">
                      <TelefoneMaskInput
                        value={formatTelefone(formData.telefone)}
                        onChange={e =>
                          handleChange({
                            target: {
                              name: 'telefone',
                              value: unformatTelefone(e.target.value),
                            },
                          })
                        }
                        name="telefone"
                        ref={el => (refs.current.telefone = el)}
                        type="text"
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>

                  {/* Celular */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">Celular</label>
                    <div className="input-group input-group-sm">
                      <CelularMaskInput
                        value={formatCelular(formData.celular)}
                        onChange={e =>
                          handleChange({
                            target: {
                              name: 'celular',
                              value: unformatCelular(e.target.value),
                            },
                          })
                        }
                        name="celular"
                        ref={el => (refs.current.celular = el)}
                        type="text"
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-12 col-sm-6 col-md-6">
                    <label className="form-label mb-1">E-mail</label>
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Logradouro */}
                  <div className="col-12 col-sm-6 col-md-5">
                    <label className="form-label mb-1">Logradouro</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="logrNome"
                      value={formData.logrNome}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Número */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">Número</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="logrNum"
                      value={formData.logrNum}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Complemento */}
                  <div className="col-12 col-sm-6 col-md-4">
                    <label className="form-label mb-1">Complemento</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="logrCompl"
                      value={formData.logrCompl}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Bairro */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">Bairro</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="logrBairro"
                      value={formData.logrBairro}
                      onChange={handleChange}
                    />
                  </div>

                  {/* CEP */}
                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label mb-1">CEP</label>
                    <div className="input-group input-group-sm">
                      <CEPMaskInput
                        value={formatCEP(formData.logrCep)}
                        onChange={e =>
                          handleChange({
                            target: {
                              name: 'logrCep',
                              value: unformatCEP(e.target.value),
                            },
                          })
                        }
                        name="logrCep"
                        ref={el => (refs.current.cep = el)}
                        type="text"
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>

                  {/* UF */}
                  <div className="col-md-2">
                    <label className="form-label mb-1">UF</label>
                    <select
                      className="form-select form-select-sm"
                      value={formData.logrUf}
                      onChange={handleChange}
                      name="logrUf"
                    >
                      <option value="">Selecione...</option>
                      {UFs.map((uf, index) => (
                        <option key={index} value={uf.sigla}>
                          {uf.sigla}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Cidade */}
                  <div className="col-md-4">
                    <label className="form-label mb-1">Cidade</label>
                    <select
                      className="form-select form-select-sm"
                      value={formData.logrCidade}
                      onChange={handleChange}
                      name="logrCidade"
                    >
                      <option value="">Selecione...</option>
                      {cidades.map((cidade, index) => (
                        <option key={index} value={cidade.nome}>
                          {cidade.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={onClose}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-success btn-sm">
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <DefaultModal
        show={modalData.show}
        type={modalData.type}
        onClose={closeDefaultModal}
        message={modalData.message}
      />
    </>
  );
}

export default FavorecidoModal;
